import React from 'react';
import { FaShare, FaCopy, FaCheck } from 'react-icons/fa';

export function ShareAlbumModal({ show, album, shareLink, copied, onCopy, onClose }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="share-album-modal">
        <div className="flex items-center space-x-3 mb-4">
          <div className="p-3 bg-purple-100 rounded-full">
            <FaShare className="text-purple-600" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-800">Share Album</h3>
            <p className="text-sm text-gray-600">{album?.name}</p>
          </div>
        </div>
        
        {shareLink ? (
          <>
            <p className="text-gray-600 mb-4">
              Anyone with this link can view the album and download photos. Link expires in 7 days.
            </p>
            
            <div className="flex items-center space-x-2 mb-4">
              <input
                type="text"
                value={shareLink}
                readOnly
                className="flex-1 px-3 py-2 bg-gray-100 border rounded-lg text-sm"
                data-testid="share-link-input"
              />
              <button
                onClick={onCopy}
                className={`px-4 py-2 rounded-lg flex items-center space-x-2 ${copied ? 'bg-green-600 text-white' : 'bg-purple-600 text-white hover:bg-purple-700'}`}
                data-testid="copy-share-link"
              >
                {copied ? <FaCheck /> : <FaCopy />}
                <span>{copied ? 'Copied!' : 'Copy'}</span>
              </button>
            </div>
          </>
        ) : (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
            <span className="ml-3 text-gray-600">Generating link...</span>
          </div>
        )}
        
        <button onClick={onClose} className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 mt-4">
          Close
        </button>
      </div>
    </div>
  );
}
